<template>
	<div>
		<div class="w-full flex items-center justify-center bg-rypert-primary">
			<img
				src="../assets/banner.png"
				alt=""
			/>
		</div>
		<nav class="bg-rypert-navbar">
			<div class="
			max-w-7xl
			mx-auto
			px-4
			sm:px-6
			lg:px-8">
				<div class="flex items-center justify-between h-16">
					<div class="flex items-center">
						<div class="hidden md:block">
							<div class="ml-10 flex items-baseline">
								<router-link
									v-for="page in pages"
									:key="page.index"
									:to="page.path"
									class="px-3 py-2 mr-6 rounded-md text-sm font-medium text-white focus:text-white focus:bg-rypert-navbarSelected"
									:class="
										pageName === page.name
											? 'bg-rypert-navbarSelected'
											: 'hover:bg-rypert-navbarSelected'
									"
								>{{ page.name }}</router-link>
							</div>
						</div>
					</div>
					<div class="hidden md:block">
						<div class="ml-4 flex items-center md:ml-6">
							<button
								@click="redirect('/cart')"
								class="p-1 border-2 border-transparent text-gray-400 rounded-full hover:text-white focus:outline-none focus:text-white focus:bg-rypert-navbarSelected"
								:class="pageName === 'Cart' ? 'bg-rypert-navbarSelected' : ''"
								aria-label="Notifications"
								style="position: relative; display: inline-block;"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24"
									height="24"
									fill="currentColor"
								>
									<path
										class="heroicon-ui"
										d="M17 16a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.62-.1A3 3 0 0 1 5 12V4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v1h14a1 1 0 0 1 .9 1.45l-4 8a1 1 0 0 1-.9.55H5a1 1 0 0 0 0 2h12zM7 12h9.38l3-6H7v6zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
									/>
								</svg>

								<div
									v-if="totalCart"
									class="w-5 h-5 bg-red-400 rounded-full flex bottom-5 absolute"
									style="bottom: 15px; left: 17px;"
								>
									<span class="text-white text-xs m-auto font-bold">
										{{ totalCart }}
									</span>
								</div>
							</button>
						</div>
					</div>
					<div class="-mr-2 flex md:hidden">
						<!-- Mobile menu button -->
						<button
							@click="isMobileMenuOpen = !isMobileMenuOpen"
							class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-rypert-navbarSelected focus:outline-none focus:bg-rypert-navbarSelected focus:text-white"
						>
							<!-- Menu open: "hidden", Menu closed: "block" -->
							<svg
								class="block h-6 w-6"
								stroke="currentColor"
								fill="none"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M4 6h16M4 12h16M4 18h16"
								/>
							</svg>
							<!-- Menu open: "block", Menu closed: "hidden" -->
							<svg
								class="hidden h-6 w-6"
								stroke="currentColor"
								fill="none"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>

			<!--
      Mobile menu, toggle classes based on menu state.

      Open: "block", closed: "hidden"
    -->
			<div :class="isMobileMenuOpen ? '' : 'hidden md:hidden'">
				<div class="px-2 pt-2 pb-3 sm:px-3">
					<router-link
						v-for="page in pages"
						:key="page.index"
						:to="page.path"
						class="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-white focus:bg-rypert-navbarSelected"
						:class="pageName === page.name ? 'bg-rypert-navbarSelected' : ''"
					>{{ page.name }}</router-link>
				</div>
			</div>
		</nav>

		<header
			v-if="pageName"
			class="bg-white shadow"
		>
			<div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
				<h1 class="text-3xl font-bold leading-tight text-gray-900">
					{{ pageName }}
				</h1>
			</div>
		</header>
	</div>
</template>

<script>
export default {
	name: "RpNav",
	props: {
		pageName: String,
		pages: Array
	},
	data() {
		return {
			isMobileMenuOpen: false
		};
	},
	created() {
		window.addEventListener("resize", this.handleResize);
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener("resize", this.handleResize);
	},
	computed: {
		windowWidth() {
			return window.innerWidth;
		},
		totalCart() {
			return this.$store.state.myArticles.length;
		}
	},
	methods: {
		handleResize() {
			if (window.innerWidth >= 700) {
				this.isMobileMenuOpen = false;
			}
		},
		redirect(route) {
			this.$router.push(route);
		}
	}
};
</script>

<style></style>
